import { render, staticRenderFns } from "./amountSetting.vue?vue&type=template&id=d5333bf6&scoped=true"
import script from "./amountSetting.vue?vue&type=script&lang=js"
export * from "./amountSetting.vue?vue&type=script&lang=js"
import style0 from "./amountSetting.vue?vue&type=style&index=0&id=d5333bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5333bf6",
  null
  
)

export default component.exports